import React from 'react';
import { LucideIcon } from 'lucide-react';

interface PrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: LucideIcon;
  label: string;
  className?: string;
  variant?: 'primary' | 'secondary' | 'danger';
  showLabelOnMobile?: boolean;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  icon: Icon,
  label,
  className = "",
  variant = 'primary',
  showLabelOnMobile = false,
  ...props
}) => {
  const baseStyles = "flex items-center gap-2 px-5 py-2.5 font-bold rounded-xl transition-all active:scale-95 shadow-lg flex-shrink-0 disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100 disabled:hover:scale-100";

  const variants = {
    primary: "bg-clip-500 hover:bg-clip-600 text-white shadow-clip-200 hover:scale-105",
    secondary: "bg-white border border-gray-200 text-gray-700 hover:bg-gray-50 shadow-sm",
    danger: "bg-red-500 hover:bg-red-600 text-white shadow-red-200"
  };

  // Label hidden on mobile only if there is an icon AND showLabelOnMobile is false
  const hideLabel = Icon && !showLabelOnMobile;

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${className}`}
      {...props}
    >
      {Icon && <Icon size={20} />}
      <span className={hideLabel ? "hidden sm:inline" : ""}>{label}</span>
    </button>
  );
};

export default PrimaryButton;